export default function($) {
  let spaSwiper = document.querySelector('.js-spa-slider');
  let mobileSwiper = document.querySelector('.js-mobile-slider');

  let initSpaSwiper = false;
  let initMobileSwiper = false;

  const homeSwiper = new Swiper('.js-home-slider', {
    speed: 750,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: "#home-swiper-pagination",
      clickable: true,
    },
  });

  const spaSwiperParams = {
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 32,
    pagination: {
      el: "#spa-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1.3,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 2.3,
        spaceBetween: 16,
      },
    },
    on: {
      init: function() {
        $('.js-spa-slider').find('.swiper-slide').height('auto')
      },
      slideChange: function() {
        $('.js-spa-slider').find('.swiper-slide').height('auto')
      },
      resize: function() {
        $('.js-spa-slider').find('.swiper-slide').height('auto')
      }
    },
  };

  const mobileSwiperParams = {
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: "#mobile-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1.3,
        spaceBetween: 32,
      },
    },
  };

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( $(window).width() < 1024 ) {
      if( !initMobileSwiper ) {
        initMobileSwiper = true;

        $('.js-mobile-slider').each(function(index) {
          let sliderDiv = $(this)[0]
          mobileSwiper = new Swiper(sliderDiv, mobileSwiperParams);
        })
      }

      if( !initSpaSwiper ) {
        initSpaSwiper = true;

        spaSwiper = new Swiper('.js-spa-slider', spaSwiperParams);
      }
    }
    else {
      if( $('.js-spa-slider').length) {
        let spaSliderDiv = $('.js-spa-slider')[0]
        if (spaSliderDiv.swiper) {
          spaSliderDiv.swiper.destroy(false,true)
        }

        initSpaSwiper = false
      }

      if( $('.js-mobile-slider').length) {
        $('.js-mobile-slider').each( function() {
          let sliderDiv = $(this)[0]
          if (sliderDiv.swiper) {
            sliderDiv.swiper.destroy(false,true)
          }
        })

        initMobileSwiper = false
      }

    }
  }

}
